import { render, staticRenderFns } from "./giftviewLog.vue?vue&type=template&id=c44a7706&scoped=true&"
import script from "./giftviewLog.vue?vue&type=script&lang=js&"
export * from "./giftviewLog.vue?vue&type=script&lang=js&"
import style0 from "./giftviewLog.vue?vue&type=style&index=0&id=c44a7706&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c44a7706",
  null
  
)

export default component.exports